
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface MessageFieldProps {
  message: string;
  setMessage: (value: string) => void;
  reagentOwner: string;
}

const MessageField: React.FC<MessageFieldProps> = ({ message, setMessage, reagentOwner }) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="space-y-2">
          <Label htmlFor="message">
            Message to {reagentOwner} <span className="text-red-500">*</span>
          </Label>
          <Textarea
            id="message"
            value={message}
            onChange={handleChange}
            placeholder={`Hello, I'm interested in your reagent. I would like to request a swap...`}
            className="min-h-[120px]"
          />
          <p className="text-xs text-muted-foreground">
            Include any additional information that might be relevant for your swap request.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default MessageField;
